import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.7274 15.2339C23.226 14.348 23.6417 13.5486 23.8981 12.9402C25.1431 9.98592 23.912 6.58765 20.9026 5.20146C17.8931 3.81526 14.8712 5.25262 13.5449 8.02786C11.0087 6.28756 7.62556 6.54315 5.75984 9.25894C3.89411 11.9747 4.47966 15.5227 7.03504 17.4587C8.19479 18.3373 10.4885 19.6322 12.6479 20.7846M23.7296 17.6666C23.1668 14.6426 20.5938 12.4311 17.3542 13.0322C14.1146 13.6333 12.0198 16.5561 12.4578 19.732C12.8097 22.2836 14.7519 28.2703 15.5019 30.5253C15.6042 30.833 15.6554 30.9869 15.7567 31.0942C15.845 31.1876 15.9623 31.2554 16.0874 31.2851C16.231 31.3192 16.3898 31.2866 16.7075 31.2213C19.0354 30.7433 25.1911 29.432 27.5768 28.4609C30.5462 27.2523 32.0786 23.9788 30.9308 20.8706C29.783 17.7624 26.6298 16.642 23.7296 17.6666Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgComp;
